import { Alert } from "@hdir/ui/alert";
import { useState } from "react";

const storageKey = "dismissed_maintenance-2026-10-06";

const MaintenanceAlert = ({ className }: { className?: string }) => {
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(storageKey) === "true"
  );

  if (dismissed) return null;

  return (
    <Alert
      variant="warning"
      title="Planlagt vedlikehold"
      fullWidth
      className={className}
      onClose={() => {
        sessionStorage.setItem(storageKey, "true");
        setDismissed(true);
      }}
    >
      Tirsdag 6. Oktober kl 17-22 er det planlagt vedlikehold på FinnKode og FAT
      API. Dette kan medføre midlertidige forstyrrelser i tjenestene.
    </Alert>
  );
};

export default MaintenanceAlert;
